import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import {
  Box,
  Tooltip as MuiTooltip,
  Paper,
  type SxProps,
  type Theme,
  Typography,
} from "@mui/material";
import type { ReactNode } from "react";

interface ChartContainerProps {
  title: string;
  children: ReactNode;
  sx?: SxProps<Theme>;
  titleTooltip?: ReactNode;
}

export const ChartContainer = ({
  title,
  children,
  sx,
  titleTooltip,
}: ChartContainerProps) => {
  const hasCustomHeight = sx && typeof sx === "object" && "height" in sx;
  const innerHeight = hasCustomHeight
    ? "calc(100% - 60px)"
    : "calc(400px - 60px)";

  return (
    <Paper
      sx={{
        p: 3,
        height: "100%",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        position: "relative",
        ...sx,
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
        <Typography
          variant="graphLabel"
          fontSize={24}
          sx={{
            color: "#333",
          }}
        >
          {title}
        </Typography>
        {titleTooltip && (
          <MuiTooltip
            title={titleTooltip}
            arrow
            placement="top"
            componentsProps={{
              tooltip: {
                sx: {
                  bgcolor: "white",
                  color: "#000",
                  border: "1px solid #ccc",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                  "& .MuiTooltip-arrow": {
                    color: "white",
                    "&::before": {
                      border: "1px solid #ccc",
                    },
                  },
                },
              },
            }}
          >
            <InfoOutlinedIcon sx={{ color: "common.grey5" }} fontSize="small" />
          </MuiTooltip>
        )}
      </Box>
      <Box
        sx={{
          width: "100%",
          height: innerHeight,
          position: "relative",
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {children}
      </Box>
    </Paper>
  );
};
